import { useState, useRef, useEffect } from 'react'
import { CURRENCY_LIST } from '../utils/currencies'

const NAVY = '#0B1F3A'
const TEAL = '#2DD4BF'
const WARM_WHITE = '#F7F9FC'

function CurrencyPicker({ value = 'BDT', onChange, label = 'Currency' }) {
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(false)
  const dropdownRef = useRef()

  const selected = CURRENCY_LIST.find(c => c.code === value) || CURRENCY_LIST[0]

  const filtered = search.trim()
    ? CURRENCY_LIST.filter(c => c.searchText.includes(search.toLowerCase()))
    : CURRENCY_LIST

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false)
        setSearch('')
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [])

  const handleSelect = (code) => {
    onChange(code)
    setOpen(false)
    setSearch('')
  }

  return (
    <div>
      {label && (
        <label className="text-xs text-gray-500 font-medium mb-1 block">{label}</label>
      )}
      <div className="relative" ref={dropdownRef}>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="w-full flex items-center gap-2.5 border border-gray-200 rounded-lg px-3 py-2.5 text-xs transition-colors"
          style={{
            background: WARM_WHITE,
            borderColor: open ? TEAL : '#E2E8F0',
          }}>
          <span style={{ fontSize: '16px' }}>{selected.flag}</span>
          <span className="font-medium" style={{ color: NAVY }}>{selected.code}</span>
          <span className="text-gray-400 flex-1 text-left">{selected.label}</span>
          <span className="font-bold flex-shrink-0" style={{ color: TEAL }}>{selected.symbol}</span>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={NAVY}
            strokeWidth="2.5" strokeLinecap="round"
            style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.15s', flexShrink: 0 }}>
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>

        {open && (
          <div className="absolute left-0 top-full mt-1 bg-white rounded-xl shadow-xl border border-gray-100 z-50 w-full"
            style={{ maxHeight: '320px', overflow: 'hidden' }}>

            {/* Search */}
            <div className="p-2 border-b border-gray-100">
              <input
                type="text"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search currency or country..."
                autoFocus
                className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-xs outline-none"
                style={{ background: WARM_WHITE }}
                onFocus={e => e.target.style.borderColor = TEAL}
                onBlur={e => e.target.style.borderColor = '#E2E8F0'} />
            </div>

            {/* List */}
            <div style={{ maxHeight: '260px', overflowY: 'auto' }}>
              {filtered.length === 0 ? (
                <div className="px-3 py-4 text-xs text-gray-400 text-center">No results</div>
              ) : (
                filtered.map(c => (
                  <button
                    key={c.code}
                    type="button"
                    onClick={() => handleSelect(c.code)}
                    className="w-full flex items-center gap-2.5 px-3 py-2.5 text-left transition-colors"
                    style={{
                      background: c.code === value ? WARM_WHITE : 'transparent',
                    }}
                    onMouseEnter={e => { if (c.code !== value) e.currentTarget.style.background = '#F9FAFB' }}
                    onMouseLeave={e => { if (c.code !== value) e.currentTarget.style.background = 'transparent' }}>
                    <span style={{ fontSize: '18px', flexShrink: 0 }}>{c.flag}</span>
                    <div className="flex-1 min-w-0">
                      <div className="text-xs font-medium truncate" style={{ color: NAVY }}>
                        {c.country}
                      </div>
                      <div className="text-xs text-gray-400 truncate">{c.label}</div>
                    </div>
                    <div className="text-right flex-shrink-0">
                      <div className="text-xs font-bold" style={{ color: TEAL }}>{c.symbol}</div>
                      <div className="text-xs text-gray-400" style={{ fontFamily: 'JetBrains Mono' }}>
                        {c.code}
                      </div>
                    </div>
                    {c.code === value && (
                      <span className="text-xs ml-1" style={{ color: TEAL }}>✓</span>
                    )}
                  </button>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CurrencyPicker